import React from 'react';
import { FormattedHTMLMessage as H, FormattedMessage as M } from 'react-intl';

export const FormattedMessage = props => <M {...props} />;
export const FormattedHTMLMessage = props => <H {...props} />;
